module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-banner-4976464cd1ef5da1cbee44678ca961b6.jpg";